(function() {
  // Tempo di inattività in millisecondi (30 minuti = 1800000 ms)
  const clearCartAfter = 1800000; // 30 minuti

  // Funzione per svuotare il carrello
  function clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST'
    })
    .then(response => response.json())
    .then(data => console.log('Carrello svuotato:', data))
    .catch(error => console.error('Errore svuotamento carrello:', error));
  }

  // Timer per il controllo dell'inattività
  let timer;

  function resetTimer() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(clearCart, clearCartAfter);
  }

  // Eventi che riavviano il timer
  window.addEventListener('load', resetTimer);
  window.addEventListener('mousemove', resetTimer);
  window.addEventListener('keydown', resetTimer);
  window.addEventListener('click', resetTimer);
  window.addEventListener('scroll', resetTimer);

})();
